import React, { useState } from "react";
import { Truncate } from "../../../utils/text";
import CopyClipboard from "../../UI/Misc/copyClipboard";
import usePageStore from "../../../stores/usePageStore";

const AssetItem = (props) => {
  const [asset, setAsset] = useState(props.asset);

  const openModal = () => {
    usePageStore.getState().handleShowModal("editassetform", {
      asset: asset,
      callback: (a) => {
        setAsset(a);
      },
    });
  };

  return (
    <div
      className="secondaryitemcont"
      style={{ alignItems: "center", flexWrap: "wrap" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          overflowX: "hidden",
          cursor: "pointer",
        }}
        onClick={openModal}
      >
        <div
          className="assetimg"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "50px",
            width: "50px",
            height: "50px",
            overflow: "hidden",
          }}
        >
          <img src={asset.url} alt={asset.description} height="50px" />
        </div>
        <h3 style={{ marginLeft: "20px" }}>{Truncate(asset.name, 32)}</h3>
      </div>
      <div style={{ marginLeft: "auto" }}>
        <CopyClipboard title="Copy Image Url" text={asset.url} />
          <button
            className="flatbut iconflatbut"
            title="Edit"
            style={{
              marginLeft: "5px",
            }}
            onClick={openModal}
          >
            <i className="material-icons">more_vert</i>
          </button>
      </div>
    </div>
  );
};

export default AssetItem;
